import React from 'react';
import PropTypes from 'prop-types';

const GroupList = (props) => (
    <ul className="list-group">
        {
            props.list.map((item) => {
                return <li key={item.id} className="list-group-item" onClick={(evt) => props.listClick(item)}>
                    <div className="store-card-list__image-container flex__shrink-fixed border-radius-large">
                        <div className={"row"}>
                            <div className={"col-md-3 col-sm-2 col-3"}>
                                {
                                    item.imageTag && item.imageTag != "" &&
                                    <div className="store-card-list__image-cover">
                                        <label className="store-card-list__tag tag tag__small tag__privacy text-uppercase text-weight-bolder">
                                            {item.imageTag}
                                        </label>
                                    </div>
                                }

                                <figure className="store-card-list__image card__image">
                                    <img src={item.image} alt={item.title} />
                                </figure>
                            </div>
                            <div className={"col-md-8 col-sm-9 col-9"}>
                                <summary className="store-card-list__summary padding-left-right-small">
                                    <h3 className="store-card-list__title text-size-bigger text-weight-bolder text-omit__single-line">{item.title}</h3>
                                    {
                                        item.subtitle.length > 0 &&
                                        <div>
                                            <h6 className="store-card-list__title text-weight-bolder text-omit__single-line subtitle-color">{item.subtitle}</h6>
                                        </div>
                                    }
                                    {
                                        item.tag.length > 0 &&
                                        <div className="store-card-list__title padding-left-right-smaller">
                                            <span className="text-size-smaller store-card-list__tags-text text-omit__single-line">{item.tag.join()}</span>
                                        </div>
                                    }

                                    <ul className="store-info">
                                        <li className="store-info__item text-middle">
                                            <i className="icon icon__smaller text-middle">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>
                                            </i><span className="store-info__text text-size-smaller text-middle">{item.distanceDisplay}</span>
                                        </li>
                                    </ul>
                                </summary>
                            </div>
                        </div>
                    </div>

                </li>
            })
        }
    </ul >
);

GroupList.propTypes = {
    list: PropTypes.array.isRequired
};

GroupList.defaultProps = {

};

export { GroupList };